import React from 'react';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
import { Countdown } from './ui/Countdown';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <section className="py-20 bg-zinc-900 border-t border-sky-900/40" data-id="element-58">
      <div className="container mx-auto px-4 text-center max-w-3xl" data-id="element-59">
        <div className="mb-10" data-id="element-60">
          <p className="text-red-400 font-bold uppercase tracking-wider mb-4" data-id="element-61">
            ⏰ EL PRECIO CIERRA EN:
          </p>
          <Countdown theme="danger" className="scale-110" data-id="element-62" />
        </div>

        <div className="space-y-6 mb-12" data-id="element-63">
          <div className="bg-black p-6 rounded-2xl border-2 border-sky-400 shadow-xl flex flex-col sm:flex-row items-center justify-between gap-6 relative overflow-hidden" data-id="element-64">
            <div className="text-left" data-id="element-65">
              <h3 className="font-bold text-lg text-white" data-id="element-66">
                🇦🇷 MEGAPACK STICKERS MUNDIAL™
              </h3>
              <p className="text-sm text-sky-300" data-id="element-67">+7.000 Stickers</p>
            </div>
            <div className="flex flex-col items-center sm:items-end shrink-0" data-id="element-68">
              <div className="flex items-center gap-2 mb-2" data-id="element-69">
                <span className="font-black text-xl text-white" data-id="element-70">
                  $19.990 ARS
                </span>
              </div>
              <a href="https://portugueslisto.shop/cart/47736989286594:1" target="_blank" rel="noopener noreferrer" data-id="element-71">
                <Button size="sm" variant="primary" data-id="element-72">
                  🔥 QUIERO MI MEGAPACK AHORA
                </Button>
              </a>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm text-zinc-200 font-medium" data-id="element-73">
          <div className="flex items-center gap-1.5" data-id="element-74">
            <Lock className="w-4 h-4 text-sky-300" data-id="element-75" />
            <span data-id="element-76">Pago 100% seguro</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-77">
            <Zap className="w-4 h-4 text-sky-400" data-id="element-78" />
            <span data-id="element-79">Descarga en 5 minutos</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-80">
            <Shield className="w-4 h-4 text-sky-400" data-id="element-81" />
            <span data-id="element-82">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-83">
            <CreditCard className="w-4 h-4 text-sky-300" data-id="element-84" />
            <span data-id="element-85">Mercado Pago | Tarjeta | Transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}